import { useTranslation } from "react-i18next";
import AuthLayout from "../layout/Auth/index.layout";
import authRoutes from "./auth.route";
import { userRoutes } from "./User";
import { adminRoutes } from "./Admin";
import MainLayout from "../layout/Main/index.layout";
import NotFound from "../pages/notFound";

export const routes = () => {
  const { t } = useTranslation();
  return [
    {
      element: <AuthLayout />,
      children: [...authRoutes(t)],
    },
    {
      element: <MainLayout />,
      children: [...userRoutes(t), ...adminRoutes(t)],
    },
    {
      path: "*",
      element: <NotFound />,
    },
  ];
};

export const routesList = () => {
  const { t } = useTranslation();
  let routeArr = [
    ...authRoutes(t),
    ...userRoutes(t)[0].children,
    ...adminRoutes(t)[0].children,
  ];
  return [...routeArr];
};

export const moduleRoutesList = () => {
  const { t } = useTranslation();
  let routeArr = {
    user: [
      ...userRoutes(t)[0].children,
      // ...userRoutes(t)[1].children
    ],
    admin: [
      ...adminRoutes(t)[0].children,
      // ...adminRoutes(t)[1].children
    ],
  };
  return routeArr;
};

export const getCompletePathList = () => {
  return routesList().reduce((prev, curr) => {
    prev.push(curr);
    if (curr.children) {
      prev.push(...curr.children);
    }
    return prev;
  }, []);
};
